import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { useClientTranslations } from "../lib/i18n/client";
import { getJourney } from "../services/journeyService";
import type { Journey, JourneyType } from "../types/journey";

export function useJourney(
	type: JourneyType | undefined,
	options?: { enabled?: boolean; locale?: string },
) {
	const enabled = options?.enabled ?? true;
	const locale = options?.locale ?? "en";
	const { t } = useClientTranslations("journey");

	return useQuery<Journey>({
		queryKey: ["journey", type, locale],
		queryFn: async () => {
			if (!type) {
				throw new Error("useJourney called without a journey type");
			}
			const result = await getJourney(type, locale);
			if (result.source === "fallback") {
				toast.warning(t("cdnFallback"));
			}
			return result.journey;
		},
		enabled: !!type && enabled,
		staleTime: 5 * 60 * 1000,
		gcTime: Number.POSITIVE_INFINITY,
		refetchOnWindowFocus: false,
	});
}
